<template>
  <div class="sku-price">
    <div class="sku-price-type">
      优惠价:
      <span>
        ¥
        <em>{{ sku | skuPrice }}</em>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'productPrice',
  components: {
  },
  props: {
    sku: {
      type: Object
    }
  },
  filters: {
    skuPrice (sku) {
      return (sku.activity && sku.activity.discount) || (sku.equity && sku.equity.discount) || sku.market_price
    }
  }
}
</script>

<style lang="less" scoped>
.sku-price-type {
  color: @price;
  font-size: @fz22;
  padding: 0.16rem 0;
  white-space: nowrap;
  span {
    font-size: 0.18rem;
    padding-left: 0.05rem;
    padding-right: 0.16rem;
  }
  em {
    font-size: @fz28;
    font-weight: bold;
  }
  .market-price {
    font-size: @fz22;
    color: @del;
  }
}
</style>
